import { SelectionSourceCitation } from '../internal';
/**
 * @ignore
 */
export const SelectionWithSourceCitationMixin = (Base) => class extends Base {
    /**
     * Source citations related to this entity.
     * <table>
     *  <tr><th>Tag</th><td><code>SOUR</code></td></tr>
     *  <tr><th>Multiplicity</th><td><code>*</code></td></tr>
     * </table>
     */
    getSourceCitation() {
        return this.get("SOUR" /* Tag.Source */, null, SelectionSourceCitation);
    }
};
//# sourceMappingURL=SelectionWithSourceCitationMixin.js.map